import React from 'react';
import ParentsRegistrationForm from './parentRegistrationForm';

const ParentsComponent = () => {
  return <ParentsRegistrationForm />;
};
export default ParentsComponent;
